/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import ClampLines from 'react-clamp-lines';
import Slider from 'react-slick';
import { ReviewProps } from './index';


const settings = {
  dots: true,
  speed: 500,
  autoplaySpeed: 10000,
  autoplay: true,
  infinite: true,
  arrows: true,
  draggable: true,
  touchMove: true,
  swipeToSlide: true,
  cssEase: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
  swipe: true,
  slidesToShow: 1,
  pauseOnHover: true
};

interface Props {
  heading: string
  reviews: ReviewProps[]
}

const Reviews = (props: Props) => {
  const { heading, reviews } = props;

  return <div className='review-container mt-5'>
    <h2 className='mb-4 strong'>{heading}</h2>
    <div className='row-inner review-content'>
      <Slider {...settings}>
        {reviews.map((review, i) =>
          <div key={i} className='d-flex flex-column flex-lg-row px-4 media-slide-inner'>
            <div className='mx-3'>
              <div className='medias-spiel'>
                <ClampLines id={`media_${review.id}`} text={review.review} />
              </div>
              <div className='strong my-2 text-right'>
                {review.partner}
              </div>
            </div>
          </div>
        )}
      </Slider>
    </div>

  </div>
}

export default Reviews;
